import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "../firebase";

export type LeadSourceType = "website" | "registration" | "course_finder" | "uec";

type LeadSource = {
  type: LeadSourceType;
  externalSubmissionId: string;
  campaign?: string;
  submittedAt?: string;
};

const functions = getFunctions(app, "asia-southeast1");
const ingestLeadCallable = httpsCallable(functions, "ingestLead");
const registerUecPortalLeadCallable = httpsCallable(
  functions,
  "registerUecPortalLead",
);

export const createLeadSubmissionId = () => crypto.randomUUID();

export async function ingestLead(
  lead: Record<string, unknown>,
  source: LeadSource,
) {
  return ingestLeadCallable({ lead, source });
}

export async function registerUecPortalLead(
  leadData: Record<string, unknown>,
  externalSubmissionId: string,
) {
  return registerUecPortalLeadCallable({ leadData, externalSubmissionId });
}
